// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { BootstrapVue } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import VueSocketIO from 'vue-socket.io'
import moment from 'moment'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(VueApexCharts)
Vue.use(BootstrapVue)

Vue.component('apexchart', VueApexCharts)

Vue.use(new VueSocketIO({
  debug: true,
  connection: store.state.launchpadUrl,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
  // options: { path: "server/:id" } //Optional options
}))

Vue.filter('relativeDate', date => {return moment(date).fromNow()})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js